// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type { BrandSpecial } from '@iheartjane/data-access';
import {
  Box,
  Card,
  Flex,
  PartnerLogo,
  ReadMore,
  Typography,
} from '@iheartjane/reefer';

import { useShouldShowGold } from '@jane/shared/hooks';
import type { Brand } from '@jane/shared/types';

import { LAYOUT_MAX_WIDTH } from '../pageLayout/pageLayout';
import { JaneGoldSubheader } from './janeGoldSubheader/janeGoldSubheader';

export const DesktopBrandDetail = ({
  brand,
  brandSpecials = [],
  isGuestUser,
  isJaneGoldMember,
}: {
  brand: Brand;
  brandSpecials?: BrandSpecial[];
  isGuestUser?: boolean;
  isJaneGoldMember?: boolean;
}) => {
  const { name, logo_url, description, custom_images, custom_video } = brand;

  const shouldShowGold = useShouldShowGold() && brandSpecials.length > 0;

  const numberOfAssets =
    (custom_images?.length || 0) + (custom_video == null ? 0 : 1);

  return (
    <DesktopBrandContainer
      data-testid="brand-detail-desktop"
      numberOfAssets={numberOfAssets}
    >
      <Flex width="100%" justifyContent="center">
        <Box maxWidth={LAYOUT_MAX_WIDTH} px={24} width="100%">
          <Card width="100%" flat border="grays-light">
            <Card.Content>
              <Flex p={32}>
                <PartnerLogo variant="brand" name={name} image={logo_url} />
                <Flex ml={24} width="calc(100% - 96px)" alignItems="center">
                  <div style={{ whiteSpace: 'pre-wrap' }}>
                    <Typography variant="h1-semibold">{name}</Typography>
                    {description && (
                      <Typography as="h2" mt={24}>
                        <ReadMore
                          content={description}
                          more="View more"
                          less="View less"
                        />
                      </Typography>
                    )}
                    {shouldShowGold && (
                      <JaneGoldSubheader
                        brandName={name}
                        isGuestUser={isGuestUser}
                        isJaneGoldMember={isJaneGoldMember}
                      />
                    )}
                  </div>
                </Flex>
              </Flex>
            </Card.Content>
          </Card>
        </Box>
      </Flex>
    </DesktopBrandContainer>
  );
};

const DesktopBrandContainer = styled.div<{ numberOfAssets: number }>(
  ({ numberOfAssets }) => ({
    position: 'relative' as const,
    bottom: numberOfAssets > 0 ? 70 : 96,
    marginBottom: numberOfAssets > 0 ? -70 : -96,
    zIndex: 1,
  })
);
